// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { DocumentAction } from "../../types";

const documentActionsModule = {
  async create(data: Omit<DocumentAction, 'id' | 'created_at'>): Promise<DocumentAction> {
    const result = await sql`
      INSERT INTO document_actions (
        document_id, user_id, action_type, action_data
      )
      VALUES (
        ${data.document_id}, ${data.user_id}, ${data.action_type}, ${data.action_data}
      )
      RETURNING *
    `;
    return result[0] as DocumentAction;
  },

  async findByDocumentId(documentId: string, userId: string): Promise<DocumentAction[]> {
    const result = await sql`
      SELECT * FROM document_actions
      WHERE document_id = ${documentId} AND user_id = ${userId}
      ORDER BY created_at DESC
    `;
    return (result || []) as DocumentAction[];
  }
};

export type DocumentActionsModule = typeof documentActionsModule;

export function registerDocumentActions(db: { documentActions?: DocumentActionsModule }) {
  db.documentActions = documentActionsModule;
}

export { documentActionsModule as documentActions };
